import { render } from "./AppSelect.vue?vue&type=template&id=2f5b6b7b"
import script from "./AppSelect.vue?vue&type=script&lang=js"
export * from "./AppSelect.vue?vue&type=script&lang=js"

import "./AppSelect.vue?vue&type=style&index=0&id=2f5b6b7b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__